// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ae6f5d8f","453":"a5ba9120","455":"afc92e82","977":"a0692e64"}[chunkId] + ".chunk.js";
};